module.exports = __webpack_public_path__ + "media/add-ons/all_hands@2x-fa5792f8.png";